import styles from '@containers/ErrorPages/ErrorPages.module.css';

import Img404 from '@assets/svg/404_img.svg';

const renderDefaultServerError = () => (
  <>
    Our apologies. This error is on our side, try refreshing or contact us on
    <b> support@didxl.com.</b>
  </>
);

export const Page500 = ({
  title = 'Server error',
  getMessage = renderDefaultServerError,
}) => (
  <div className="text-center">
    <Img404 className={styles.manIcon} />
    <h3 className={styles.title}>{title}</h3>
    <p className={styles.info}>{getMessage()}</p>
  </div>
);
